// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"f230d0b3","305":"96efc656","678":"c9fad5c2","805":"285a8f17","884":"ba1be1f4","950":"bde88b84"}[chunkId] + ".chunk.js";
};